<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2">
            <i class="fa fa-file-text-o text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Retorno de Boletos</h4>
            <p class="text-muted mb-0 small">Lista de arquivos de retorno processados</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <CecInputData ref="dt1Input" v-model="dt1" class="mx-1" style="width: 130px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1 small font-weight-bold">até</span>
                    <CecInputData v-model="dt2" class="mx-1" style="width: 130px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Novo Retorno</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">ID</label>
                      <b-form-input type="text" v-model="filtros.ID" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Banco</label>
                      <b-form-input type="text" v-model="filtros.NOME_BANCO" placeholder="Banco" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Agência</label>
                      <b-form-input type="text" v-model="filtros.AGENCIA" placeholder="Agência" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="4">
                      <label class="font-weight-bold text-muted small">Conta</label>
                      <b-form-input type="text" v-model="filtros.CONTA" placeholder="Conta" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-3">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              class="modern-premium-table mb-0"
              id="table-retorno"
              ref="tbl"
              show-empty
              empty-text="Informe o filtro para ver os registros"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              :dark="isDark"
              @row-dblclicked="abrirCadastro"
              @row-clicked="clicarLinha"
              :tbody-tr-class="rowClassSelecionado"
            >

              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(DATA_CADASTRO)>
                <SetFilter label="Data Cadastro" v-model="filtros.DATA_CADASTRO" :options="opcoes.DATA_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(NOME_BANCO)>
                <SetFilter label="Banco" v-model="filtros.NOME_BANCO" :options="opcoes.NOME_BANCO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(AGENCIA)>
                <SetFilter label="Agência" v-model="filtros.AGENCIA" :options="opcoes.AGENCIA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(CONTA)>
                <SetFilter label="Conta" v-model="filtros.CONTA" :options="opcoes.CONTA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(USUARIO_CADASTRO)>
                <SetFilter label="Usuário" v-model="filtros.USUARIO_CADASTRO" :options="opcoes.USUARIO_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(NOME_ARQUIVO_RETORNO)>
                <SetFilter label="Nome Arquivo" v-model="filtros.NOME_ARQUIVO_RETORNO" :options="opcoes.NOME_ARQUIVO_RETORNO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TOTAL_DE_TITULOS)>
                <SetFilter label="Total Títulos" v-model="filtros.TOTAL_DE_TITULOS" :options="opcoes.TOTAL_DE_TITULOS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(VALOR_PROCESSADO)>
                <SetFilter label="Valor Processado" v-model="filtros.VALOR_PROCESSADO" :options="opcoes.VALOR_PROCESSADO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(ID)="data">
                <span class="text-muted font-weight-bold">{{ data.value }}</span>
              </template>

              <template #cell(DATA_CADASTRO)="item">
                <span class="text-muted">{{ formatDate(item.item.DATA_CADASTRO) }}</span>
              </template>

              <template #cell(VALOR_PROCESSADO)="item">
                <span class="font-weight-bold text-primary">{{ formatCurrency(item.item.VALOR_PROCESSADO) }}</span>
              </template>

              <template #cell(acoes)="item">
                <b-button-group size="sm">
                  <b-dropdown
                    right
                    dropup
                    boundary="viewport"
                    :popper-opts="{ positionFixed: true }"
                    no-caret
                    variant="link"
                    toggle-class="p-1 text-muted no-decoration"
                    @shown="clicarLinha(item.item)"
                  >
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>

                    <b-dropdown-item @click.stop="abrirCadastro(item.item)">
                      <i class="fa fa-eye text-primary mr-2"></i> Visualizar
                    </b-dropdown-item>

                    <b-dropdown-item @click.stop="imprimirRetorno(item.item)">
                      <i class="fa fa-print text-info mr-2"></i> Imprimir
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() === '0'"
                      @click.stop="excluir(item.item)" 
                      class="text-danger">
                      <i class="fa fa-trash text-danger mr-2"></i> Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </b-button-group>
              </template>

              <template #custom-foot="{ fields, items }">
                <b-tr class="bg-light font-weight-bold">
                  <b-td colspan="7">Total de Registros: {{ itensFiltrados.length }}</b-td>
                  <b-td class="text-right text-primary">{{ totalTitulos }}</b-td>
                  <b-td class="text-right text-primary">{{ formatCurrency(totalValorProcessado) }}</b-td>
                  <b-td></b-td>
                </b-tr>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import moment from 'moment'

export default {
  components: { SetFilter, HeaderPadrao, CecInputData },
  mixins: [createCecTableToolsMixin({ 
    rowsProp: 'lista', 
    tblRef: 'tbl', 
    useExternalPaging: true, 
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DATA_CADASTRO', type: 'date', label: 'Data Cadastro' },
      { key: 'NOME_BANCO', type: 'string', label: 'Banco' },
      { key: 'AGENCIA', type: 'string', label: 'Agência' },
      { key: 'CONTA', type: 'string', label: 'Conta' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Usuário' },
      { key: 'NOME_ARQUIVO_RETORNO', type: 'string', label: 'Nome Arquivo' },
      { key: 'TOTAL_DE_TITULOS', type: 'number', label: 'Total Títulos' },
      { key: 'VALOR_PROCESSADO', type: 'number', label: 'Valor Processado' }
    ] 
  })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      lista: [],
      dt1: moment().startOf('month').format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      currentPage: 1,
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: '5%' } },
        { key: 'DATA_CADASTRO', label: 'Data Cadastro', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'NOME_BANCO', label: 'Banco', sortable: true, class:'align-middle', thStyle: { width: '15%' } },
        { key: 'AGENCIA', label: 'Agência', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'CONTA', label: 'Conta', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'NOME_ARQUIVO_RETORNO', label: 'Nome Arquivo', sortable: true, class:'align-middle', thStyle: { width: '15%' } },
        { key: 'TOTAL_DE_TITULOS', label: 'Total Títulos', sortable: true, class:'align-middle text-right', thStyle: { width: '9%' } },
        { key: 'VALOR_PROCESSADO', label: 'Valor Processado', sortable: true, class:'align-middle text-right', thStyle: { width: '11%' } },
        { key: 'acoes', label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: '5%' }, sortable: false }
      ]
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    totalTitulos() {
      return this.itensFiltrados.reduce((sum, item) => sum + (Number(item.TOTAL_DE_TITULOS) || 0), 0)
    },
    
    totalValorProcessado() {
      return this.itensFiltrados.reduce((sum, item) => sum + (Number(item.VALOR_PROCESSADO) || 0), 0)
    }
  },

  methods: {
    clicarLinha(item) { 
      this.$store.commit('boletoRetorno/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['boletoRetorno/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : '' 
    },
    
    limparFiltro() { 
      this.dt1 = moment().startOf('month').format('YYYY-MM-DD')
      this.dt2 = moment().format('YYYY-MM-DD')
      this.lista = []
      this.filtros.ID = ''
      this.filtros.NOME_BANCO = ''
      this.filtros.AGENCIA = ''
      this.filtros.CONTA = ''
    },
    
    novo() {
      this.$router.push('/faturamento/retorno/cadastro/novo')
    },
    
    abrirCadastro(item) {
      const id = item && item.ID ? item.ID : null
      if (!id) return
      this.$store.commit('boletoRetorno/SET_REGISTRO_SELECIONADO_ID', id)
      this.$router.push(`/faturamento/retorno/cadastro/${id}`)
    },

    async pesquisar() {
      if (!this.dt1 || !this.dt2) {
        this.$bvToast.toast('Informe o período (data inicial e final)', { variant: 'warning', solid: true })
        return
      }

      this.$store.commit('controle/setAguardando', true)
      try {
        const payload = {
          dt1: this.dt1,
          dt2: this.dt2
        }

        const { data } = await this.$http.post('/api/protected/boleto/retorno/pesquisar', payload)
        this.lista = Array.isArray(data) ? data : []
      } catch (err) {
        console.error('Erro ao pesquisar retornos:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao pesquisar retornos'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
        this.lista = []
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async excluir(item) {
      if (!item || !item.ID) return

      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Confirma a exclusão do retorno ${item.ID}?`,
        {
          title: 'Confirmar Exclusão',
          okVariant: 'danger',
          okTitle: 'Sim, Excluir',
          cancelTitle: 'Não'
        }
      )
      
      if (!confirmado) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/boleto/retorno/delete/${item.ID}`)
        this.$bvToast.toast('Retorno excluído com sucesso!', { variant: 'success', solid: true })
        await this.pesquisar()
      } catch (err) {
        console.error('Erro ao excluir retorno:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao excluir retorno'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    formatDate(val) { 
      return val ? moment(String(val)).format('DD/MM/YYYY') : '' 
    },
    
    formatCurrency(val) { 
      return val != null ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00' 
    },

    exportarHtml() { 
      printHtmlReport({ 
        rows: this.lista, 
        columns: this.colunas, 
        systemName: 'CECWeb', 
        reportTitle: 'Listagem de Retornos de Boletos', 
        printedBy: window.localStorage.getItem('login') ?? '—', 
        pageSize: 'A4', 
        landscape: true 
      }) 
    },
    
    exportarExcel() { 
      exportExcelXlsx({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'retorno-boletos-lista.xls' 
      }) 
    },
    
    exportarCsv() { 
      exportCsv({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'retorno-boletos-lista.csv' 
      }) 
    },

    async imprimirRetorno(item) {
      if (!item || !item.ID) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        try {
          this.$store.commit('boletoRetorno/SET_REGISTRO_SELECIONADO_ID', item.ID)
          
          const payload = {
            retornoId: item.ID,
            usuario: window.localStorage.getItem('login'),
            febrab: `FEBRAB: ${item.NR_DIGITO_FEBRABAN || ''}   BANCO: ${item.NOME_BANCO || ''}`,
            descricaoConta: `AGENCIA: ${item.AGENCIA || ''}   CONTA: ${item.CONTA || ''}`,
            nomeArquivo: item.NOME_ARQUIVO_RETORNO || '',
            dataProcessamento: `PROCESSAMENTO: ${this.formatDate(item.DATA_CADASTRO)}   USUARIO: ${item.USUARIO_CADASTRO || ''}`,
            resumo: `TITULOS ENCONTRADOS: ${item.TOTAL_DE_TITULOS || 0}   PROCESSADOS: ${item.TITULOS_ENCONTRADOS || 0}   VALOR PROCESSADO: ${this.formatCurrency(item.VALOR_PROCESSADO)}`
          }
          
          const response = await this.$http.post(
            '/api/protected/relatorios/boleto/retorno',
            payload,
            { responseType: 'arraybuffer' }
          )
          
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', `relBoletoRetorno_${item.ID}.pdf`)
          link.download = `relBoletoRetorno_${item.ID}.pdf`
          
          const janela = window.open(link)
          if (janela) {
            janela.onload = function() {
              setTimeout(() => {
                janela.document.title = `${item.ID} - Relatório de Retorno de Boletos`
              }, 2000)
            }
          }

          this.$bvToast.toast('Relatório gerado com sucesso!', { variant: 'success', solid: true })
        } catch (err) {
          console.error('Erro ao gerar relatório:', err)
          Tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', err)
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.dt1Input && this.$refs.dt1Input.$el) {
        this.$refs.dt1Input.$el.focus()
      } else if (this.$refs.dt1Input) {
        this.$refs.dt1Input.focus()
      }
    })
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('controle/setAguardando', false)
      
      const deveRecarregar = vm.$store.getters['boletoRetorno/DEVE_RECARREGAR_LISTA']
      const vindoDeCadastro = from.path && from.path.includes('/faturamento/retorno/cadastro')
      
      if (deveRecarregar || vindoDeCadastro) {
        vm.$nextTick(() => {
          vm.pesquisar()
          vm.$store.commit('boletoRetorno/SET_DEVE_RECARREGAR_LISTA', false)
        })
      }

      vm.$nextTick(() => {
        if (vm.$refs.dt1Input) {
          vm.$refs.dt1Input.focus()
        }
      })
    })
  }
}
</script>

<style lang="scss">
.list-header-premium {
  background: #fff;
  border-bottom: 1px solid #eef2f7;
  
  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    
    i {
      font-size: 1.4rem;
    }
  }
}

.card-filter-premium {
  background: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.custom-input-premium {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  padding: 0.5rem 0.75rem;
  height: 38px;
  transition: all 0.2s;
  
  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
}

.modern-premium-table {
  border-collapse: separate;
  border-spacing: 0;
  
  thead th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
    letter-spacing: 0.025em !important;
    padding: 12px 16px !important;
    border-top: none !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }
  
  tbody td {
    padding: 4px 8px !important;
    vertical-align: middle !important;
    border-bottom: 1px solid #edf2f7 !important;
    font-size: 0.875rem !important;
  }
  
  tbody tr {
    transition: all 0.2s;
    
    &:hover {
      background-color: #f1f5f9 !important;
    }
    
    &.cec-row-selected {
      background-color: #e0f2fe !important;
      td {
        color: #0369a1 !important;
        font-weight: 500;
      }
    }
  }
}

.btn-icon-only {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
</style>



// WEBPACK FOOTER //
// src/views/faturamento/boleto/BoletoRetornoListagem.vue